import { useState } from 'react';

import './Gallery.css';

interface Props {
    images: []
}

const Gallery: React.FC<Props> = (props) => {
    const [images, setImages] = useState([])

    let _slides: any = [];

    for (let i = 0; i < props.images?.length; i++) {
        let item = props.images[i];
        _slides.push({
            renderItem: () => {
                return <div className="slide" style={{ backgroundImage: 'url(' + item['url'] + ')' }}></div>
            }
        })
    }

    if (props.images?.length > 0 && images.length == 0) {
        setImages(_slides)
    }

    return <div className="gallery">
    </div>
}

export default Gallery